<template>
  <v-dialog v-model="show" max-width="500">
    <v-card>
      <v-card-title class="headline">{{ $t('components.dialog.signupWaitingForVerification.title') }}</v-card-title>

      <v-card-text>
        <p>{{ $t('components.dialog.signupWaitingForVerification.contentText1') }}</p>
        <p>{{ $t('components.dialog.signupWaitingForVerification.contentText2') }}</p>
        <p>{{ $t('components.dialog.signupWaitingForVerification.contentText3') }}</p>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn color="primary" class="black--text" @click="show = false">
          {{ $t('common.close') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    visible: Boolean,
  },

  model: {
    prop: 'visible',
    event: 'update',
  },

  computed: {
    show: {
      get: function () {
        return this.visible;
      },
      set: function (value) {
        this.$emit('update', value);

        if (value === false) {
          this.$emit('close');
        }
      },
    },
  },
};
</script>
